
import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import {
  SearchFilter,
  IFilterResponse,
} from "src/app/infrastructure/iFilter-component";
import { MatDialog } from "@angular/material";
import { BillingInvoiceSearchItem } from "src/app/model/billing/billing-invoice-search-item";
import { SearchFilterComponent } from "../../search-filter/search-filter.component";
import { PagerControlComponent } from "../../controls/pager/pager-control.component";
import { Router } from "@angular/router";
import { BillingInvoiceEntityService } from "../../../services/billing/billing-invoice/billing-invoice-entity.service";
import { BillingCloseTaskDialogComponent } from "../../dialogs/billing-close-task-dialog/billing-close-task-dialog.component";
import { ScheduledTask } from "src/app/enums/escheduled-task.enum";
import { AuthService } from "../../../services/auth.service";
import { ReportViewerDialogComponent } from "../../dialogs/report-viewer/report-viewer-dialog/report-viewer-dialog.component";
import { NotificationToastService } from "src/app/services/notification-toast.service";
import { MenuService } from "../../../services/menu.service";
import { BillingReportService } from "../../../services/billing/billing-report.service";
import { BillingReportTypeDialogComponent } from "../../dialogs/billing-report-type-dialog/billing-report-type-dialog.component";
import { ConfirmDialogService } from "../../../services/confirm-dialog.service";
import { of, Observable } from "rxjs";
import { BillingExportTypeDialogComponent } from "../../dialogs/billing-export-type-dialog/billing-export-type-dialog.component";
import { DownloadLocalFileService } from "../../../services/download-local-file.service";
import { BillingExportTypeFilter } from "../../../model/billing/billing-export-type-filter";
import { BillingExportFileService } from "../../../services/billing/billing-export-file.service";
import { CsvExportService } from "../../../services/export/csv-export.service";
import { BillingInvoiceLogDialogComponent } from "../../dialogs/billing-invoice-log-dialog/billing-invoice-log-dialog.component";
import { moveItemInArray } from "@angular/cdk/drag-drop";
import { DatePipe } from "@angular/common";

interface ColumnDefinition {
  field: string;
  title: string;
  visible: boolean;
  order: number;
  width: number;
}

@Component({
  selector: "app-billing-invoice-credit-search",
  templateUrl: "./billing-invoice-credit-search.component.html",
  styleUrls: ["./billing-invoice-credit-search.component.css"],
  providers: [DatePipe],
})
export class BillingInvoiceCreditSearchComponent implements OnInit, OnDestroy {
  searchFilters: SearchFilter[];
  dataSource: BillingInvoiceSearchItem[] = [];
  allItems: BillingInvoiceSearchItem[] = [];

  @ViewChild("searchFilter", { static: false })
  searchFilter: SearchFilterComponent;
  @ViewChild("pager", { static: true }) pager: PagerControlComponent;

  loading: boolean;
  columnFilters: { [field: string]: string } = {};

  private sessionColumnsKey = "billing-invoice-credit-search.columns.v1";
  private sessionSortKey = "billing-invoice-credit-search.sort.v1";
  private sessionColumnWidthsKey = "billing-invoice-credit-search.column-widths.v1";

  private sortField: string = null;
  private sortDirection: "asc" | "desc" = "asc";
  private dragSourceField: string = null;
  private resizeListeners: { move: EventListener; up: EventListener } = null;

  columnsDefinition: ColumnDefinition[] = [
    { field: "invoiceNumber", title: "Número", visible: true, order: 0, width: 140 },
    { field: "erpCode", title: "Código cliente", visible: true, order: 1, width: 150 },
    { field: "invoiceDate", title: "Fecha", visible: true, order: 2, width: 120 },
    { field: "amount", title: "Importe", visible: true, order: 3, width: 120 },
    { field: "alicuotsColumn", title: "Iva", visible: true, order: 4, width: 100 },
    { field: "billingGroupName", title: "Corte", visible: true, order: 5, width: 160 },
    { field: "billingGroupFrom", title: "Corte inicio", visible: false, order: 6, width: 130 },
    { field: "billingGroupTo", title: "Corte fin", visible: false, order: 7, width: 130 },
    { field: "billingGroupNumber", title: "Corte número", visible: false, order: 8, width: 130 },
  ];

  get availableColumns(): ColumnDefinition[] {
    return this.columnsDefinition;
  }

  get orderedColumnsDefinition(): ColumnDefinition[] {
    return this.columnsDefinition
      .filter(c => c.visible)
      .sort((a, b) => a.order - b.order);
  }

  exportColumns: string[] = [
    "InvoiceNumberComplete",
    "ErpCode",
    "InvoiceDate",
    "Amount",
    "AlicuotsColumn",
    "BillingGroupName",
    "BillingGroupFrom",
    "BillingGroupTo",
    "BillingGroupNumber",
  ];

  exportColumnsName: string[] = [
    "Número",
    "Código cliente",
    "Fecha",
    "Importe",
    "Iva",
    "Corte"
  ];

  constructor(
    private router: Router,
    private dialog: MatDialog,
    private authService: AuthService,
    private notificationToastService: NotificationToastService,
    private downloadLocalFileService: DownloadLocalFileService,
    private menuService: MenuService,
    private confirmDialogService: ConfirmDialogService,
    private billingReportService: BillingReportService,
    private billingExportFileService: BillingExportFileService,
    private billingInvoiceEntityService: BillingInvoiceEntityService,
    private csvExportService: CsvExportService,
    private datePipe: DatePipe
  ) {
    this.menuService.setMenuTitle("Facturas y notas de crédito", "");
  }

    async sendInvoiceMail(billingInvoiceSearchItem: BillingInvoiceSearchItem) {
    billingInvoiceSearchItem.Loading = true;
    try {
      await this.billingInvoiceEntityService.sendInvoiceMail(billingInvoiceSearchItem.InvoiceId);
      this.notificationToastService.success('El mail fue enviado correctamente.', 'Facturación');
    } catch (err) {
     this.notificationToastService.error(
        JSON.stringify(err.error),
        "Facturación"
      );
    } finally {
      billingInvoiceSearchItem.Loading = false;
    }
  }


  ngOnInit() {
    this.restoreColumns();
    this.restoreSort();
    this.restoreColumnWidths();

    this.billingReportService
      .getBillingReportTypeFilters()
      .then((values) => console.log(values));
  }

  ngOnDestroy() {
    this.removeResizeListeners();
  }

    openLogViewDialog(
      billingInvoiceSearchItem: BillingInvoiceSearchItem
    ): void {
      this.dialog.open(BillingInvoiceLogDialogComponent, {
        width: "50%",
        data: billingInvoiceSearchItem.InvoiceId,
      });
    }


  selectedPageIndexChange(pagedItems: any[]) {
    this.dataSource = [...pagedItems];
    this.loading = false;
  }

  onEndSearch(response: IFilterResponse<BillingInvoiceSearchItem>) {
    this.allItems = response.items || [];
    this.searchFilters = response.searchFilters;
    this.refreshGrid();
  }

  onStartSearch() {
    this.loading = true;
  }

  isColumnVisible(field: string): boolean {
    const col = this.columnsDefinition.find(c => c.field === field);
    return col ? col.visible : false;
  }

  setColumnVisibility(field: string, visible: boolean) {
    const col = this.columnsDefinition.find(c => c.field === field);
    if (col) {
      col.visible = visible;
      this.saveColumns();
      this.refreshGrid();
    }
  }

  showAllColumns() {
    this.columnsDefinition.forEach(c => (c.visible = true));
    this.saveColumns();
    this.refreshGrid();
  }

  private saveColumns() {
    const state = this.columnsDefinition.map(c => ({ field: c.field, visible: c.visible, order: c.order }));
    sessionStorage.setItem(this.sessionColumnsKey, JSON.stringify(state));
  }

  private restoreColumns() {
    const raw = sessionStorage.getItem(this.sessionColumnsKey);
    if (!raw) { return; }
    try {
      const state: { field: string; visible: boolean; order: number }[] = JSON.parse(raw);
      state.forEach(s => {
        const col = this.columnsDefinition.find(c => c.field === s.field);
        if (col) {
          col.visible = s.visible;
          col.order = s.order;
        }
      });
    } catch { }
  }

  sortByColumn(field: string) {
    if (this.sortField === field) {
      this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
    } else {
      this.sortField = field;
      this.sortDirection = "asc";
    }
    this.saveSort();
    this.refreshGrid();
  }

  getSortIcon(field: string): string {
    if (this.sortField !== field) { return "unfold_more"; }
    return this.sortDirection === "asc" ? "arrow_upward" : "arrow_downward";
  }

  private sortAllData(items: BillingInvoiceSearchItem[]): BillingInvoiceSearchItem[] {
    if (!this.sortField) { return items; }
    const dir = this.sortDirection === "asc" ? 1 : -1;
    return [...items].sort((a, b) => {
      const va = this.getColumnFilterValue(a, this.sortField);
      const vb = this.getColumnFilterValue(b, this.sortField);
      return va < vb ? -dir : va > vb ? dir : 0;
    });
  }

  private saveSort() {
    sessionStorage.setItem(this.sessionSortKey, JSON.stringify({ field: this.sortField, direction: this.sortDirection }));
  }

  private restoreSort() {
    const raw = sessionStorage.getItem(this.sessionSortKey);
    if (!raw) { return; }
    try {
      const s = JSON.parse(raw);
      this.sortField = s.field;
      this.sortDirection = s.direction;
    } catch { }
  }

  onColumnFilterInput(field: string, value: string) {
    this.columnFilters[field] = value;
    this.refreshGrid();
  }

  private applyColumnFilters(items: BillingInvoiceSearchItem[]): BillingInvoiceSearchItem[] {
    return items.filter(item => {
      return Object.keys(this.columnFilters).every(field => {
        const filterVal = this.normalizeFilterValue(this.columnFilters[field]);
        if (!filterVal) { return true; }
        const cellVal = this.normalizeFilterValue(this.getColumnFilterValue(item, field));
        return cellVal.includes(filterVal);
      });
    });
  }

  private getColumnFilterValue(item: BillingInvoiceSearchItem, field: string): string {
    switch (field) {
      case "invoiceNumber": return item.InvoiceNumberComplete || "";
      case "erpCode": return item.ErpCode || "";
      case "invoiceDate": return this.datePipe.transform(item.InvoiceDate, "dd/MM/yyyy") || "";
      case "amount": return item.Amount !== null && item.Amount !== undefined ? item.Amount.toString() : "";
      case "alicuotsColumn": return item.AlicuotsColumn || "";
      case "billingGroupName": return item.BillingGroupName || "";
      case "billingGroupFrom": return this.datePipe.transform(item.BillingGroupFrom, "dd/MM/yyyy") || "";
      case "billingGroupTo": return this.datePipe.transform(item.BillingGroupTo, "dd/MM/yyyy") || "";
      case "billingGroupNumber": return item.BillingGroupNumber !== null && item.BillingGroupNumber !== undefined ? item.BillingGroupNumber.toString() : "";
      default: return "";
    }
  }

  private normalizeFilterValue(value: string): string {
    if (!value) { return ""; }
    return value.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }

  private refreshGrid() {
    const filtered = this.applyColumnFilters(this.allItems);
    const sorted = this.sortAllData(filtered);
    this.pager.setItems(sorted);
  }

  getColumnWidth(field: string): number {
    const col = this.columnsDefinition.find(c => c.field === field);
    return col ? col.width : 150;
  }

  startResize(event: MouseEvent, field: string) {
    event.preventDefault();
    event.stopPropagation();
    const startX = event.clientX;
    const col = this.columnsDefinition.find(c => c.field === field);
    const startWidth = col ? col.width : 150;

    this.removeResizeListeners();

    const moveHandler: EventListener = (e: MouseEvent) => {
      const newWidth = Math.max(50, startWidth + (e.clientX - startX));
      if (col) { col.width = newWidth; }
    };
    const upHandler: EventListener = () => {
      this.removeResizeListeners();
      this.saveColumnWidths();
    };

    document.addEventListener("mousemove", moveHandler);
    document.addEventListener("mouseup", upHandler);
    this.resizeListeners = { move: moveHandler, up: upHandler };
  }

  private removeResizeListeners() {
    if (this.resizeListeners) {
      document.removeEventListener("mousemove", this.resizeListeners.move);
      document.removeEventListener("mouseup", this.resizeListeners.up);
      this.resizeListeners = null;
    }
  }

  private saveColumnWidths() {
    const widths: { [field: string]: number } = {};
    this.columnsDefinition.forEach(c => (widths[c.field] = c.width));
    sessionStorage.setItem(this.sessionColumnWidthsKey, JSON.stringify(widths));
  }

  private restoreColumnWidths() {
    const raw = sessionStorage.getItem(this.sessionColumnWidthsKey);
    if (!raw) { return; }
    try {
      const widths: { [field: string]: number } = JSON.parse(raw);
      this.columnsDefinition.forEach(c => {
        if (widths[c.field] !== undefined) { c.width = widths[c.field]; }
      });
    } catch { }
  }

  onHeaderDragStart(event: DragEvent, field: string) {
    this.dragSourceField = field;
    event.dataTransfer.effectAllowed = "move";
  }

  onHeaderDragOver(event: DragEvent) {
    event.preventDefault();
    event.dataTransfer.dropEffect = "move";
  }

  onHeaderDrop(event: DragEvent, targetField: string) {
    event.preventDefault();
    if (!this.dragSourceField || this.dragSourceField === targetField) { return; }
    const visible = this.orderedColumnsDefinition;
    const fromIdx = visible.findIndex(c => c.field === this.dragSourceField);
    const toIdx = visible.findIndex(c => c.field === targetField);
    if (fromIdx < 0 || toIdx < 0) { return; }
    moveItemInArray(visible, fromIdx, toIdx);
    visible.forEach((c, i) => {
      const col = this.columnsDefinition.find(x => x.field === c.field);
      if (col) { col.order = i; }
    });
    this.saveColumns();
    this.dragSourceField = null;
  }

  onHeaderDragEnd() {
    this.dragSourceField = null;
  }

  redirectCreateInvoiceCredit(
    billingInvoiceSearchItem: BillingInvoiceSearchItem
  ) {
    this.router.navigate([
      "billing-invoice-entity-credit-edit",
      billingInvoiceSearchItem.InvoiceId,
    ]);
  }

  async exportStudyReport(billingInvoiceSearchItem: BillingInvoiceSearchItem) {
    billingInvoiceSearchItem.Loading = true;
    const medicalAppointmentProcedureIds =
      await this.billingInvoiceEntityService.getMedicalAppointmentProcedureIds(
        billingInvoiceSearchItem.InvoiceId
      );
    billingInvoiceSearchItem.Loading = false;
    this.dialog.open(BillingCloseTaskDialogComponent, {
      width: "50%",
      data: {
        escheduledTaskId: ScheduledTask.billingExportStudyReport,
        taskName: `${this.authService
          .getUserName()
          .toUpperCase()} - EXPORTACION-INFORMES`,
        medicalAppointmentProcedureIds: medicalAppointmentProcedureIds,
        invoiceNumber: billingInvoiceSearchItem.InvoiceNumber,
        invoicePoint: billingInvoiceSearchItem.InvoicePoint,
        invoiceLabelType: billingInvoiceSearchItem.InvoiceLabelType,
      },
    });
  }

  async exportImages(billingInvoiceSearchItem: BillingInvoiceSearchItem) {
    billingInvoiceSearchItem.Loading = true;
    const medicalAppointmentProcedureIds =
      await this.billingInvoiceEntityService.getMedicalAppointmentProcedureIds(
        billingInvoiceSearchItem.InvoiceId
      );
    billingInvoiceSearchItem.Loading = false;
    this.dialog.open(BillingCloseTaskDialogComponent, {
      width: "50%",
      data: {
        escheduledTaskId: ScheduledTask.billingExportImages,
        taskName: `${this.authService
          .getUserName()
          .toUpperCase()} - EXPORTACION-IMAGENES`,
        medicalAppointmentProcedureIds: medicalAppointmentProcedureIds,
        invoiceNumber: billingInvoiceSearchItem.InvoiceNumber,
        invoicePoint: billingInvoiceSearchItem.InvoicePoint,
        invoiceLabelType: billingInvoiceSearchItem.InvoiceLabelType,
      },
    });
  }

  async viewReport(billingInvoiceSearchItem: BillingInvoiceSearchItem) {
    try {
      billingInvoiceSearchItem.Loading = true;
      const reportViewer =
        await this.billingInvoiceEntityService.getBillingInvoiceReport(
          billingInvoiceSearchItem.InvoiceId
        );

      this.dialog.open(ReportViewerDialogComponent, {
        width: "90%",
        height: "600px",
        data: reportViewer,
      });
    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Facturación"
      );
    } finally {
      billingInvoiceSearchItem.Loading = false;
    }
  }

  async viewBillingReport(billingInvoiceSearchItem: BillingInvoiceSearchItem) {
    const next$ = this.getNextObservable(billingInvoiceSearchItem);

    next$.subscribe((value) => {
      if (value) {
        const billingReportTypeDialog = this.dialog.open(
          BillingReportTypeDialogComponent,
          {
            width: "50%",
          }
        );
        billingReportTypeDialog.afterClosed().subscribe(async (id) => {
          console.log(id);
          if (id) {
            await this.showBillingReport(billingInvoiceSearchItem, id);
          }
        });
      }
    });
  }


    async exportExcelBilling(billingInvoiceSearchItem: BillingInvoiceSearchItem) {
      billingInvoiceSearchItem.Loading = true;
      await this.billingReportService.exportExcelBilling(billingInvoiceSearchItem.InvoiceId);
      billingInvoiceSearchItem.Loading = false;
    }

  async exportBilling(billingInvoiceSearchItem: BillingInvoiceSearchItem) {
    const next$ = this.getNextObservable(billingInvoiceSearchItem);

    next$.subscribe((value) => {
      if (value) {
        const billingReportTypeDialog = this.dialog.open(
          BillingExportTypeDialogComponent,
          {
            width: "50%",
            data: billingInvoiceSearchItem.PreBillingId,
          }
        );
        billingReportTypeDialog
          .afterClosed()
          .subscribe(async (exportType: BillingExportTypeFilter) => {
            if (exportType) {
              await this.downloadExportFile(
                billingInvoiceSearchItem,
                exportType
              );
            }
          });
      }
    });
  }

  private async downloadExportFile(
    billingInvoiceSearchItem: BillingInvoiceSearchItem,
    exportType: BillingExportTypeFilter
  ) {
    const base64File = await this.billingExportFileService.getBillingExportFile(
      billingInvoiceSearchItem.InvoiceId,
      exportType.id
    );
    this.downloadLocalFileService.downLoadFile(
      base64File,
      exportType.fileName,
      "txt"
    );
  }

  private getNextObservable(
    billingInvoiceSearchItem: BillingInvoiceSearchItem
  ): Observable<boolean> {
    const next$ = billingInvoiceSearchItem.HasCreditNote
      ? this.confirmDialogService.confirm(
          "Facturación",
          "Si los protocolos contenidos en esta factura fuera refacturados en otra factura la información puede ser incorrecta. Desea continuar?",
          "Sí",
          "No"
        )
      : of(true);
    return next$;
  }

  private async showBillingReport(
    billingInvoiceSearchItem: BillingInvoiceSearchItem,
    id: number
  ) {
    try {
      billingInvoiceSearchItem.Loading = true;
      const reportViewer = await this.billingReportService.getBillingReport(
        id,
        billingInvoiceSearchItem.InvoiceId,
        this.authService.getCenterId()
      );
      this.dialog.open(ReportViewerDialogComponent, {
        width: "90%",
        height: "600px",
        data: reportViewer,
      });
    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Facturación"
      );
    } finally {
      billingInvoiceSearchItem.Loading = false;
    }
  }

  exportCsv() {
    if (this.pager.getAllItems()) {
      const items: BillingInvoiceSearchItemExport[] = [];
      const columns: string[] = [
        "Nro",
        "Numero",
        "ClienteCodigo",
        "Fecha",
        "Importe",
        "Iva",
        "Corte",
      ];
      this.pager.getAllItems().forEach((item) => {
        const itemExport = new BillingInvoiceSearchItemExport();
        itemExport.Nro = "";
        itemExport.Numero = item.InvoiceNumberComplete;
        itemExport.ClienteCodigo = item.ErpCode;
        itemExport.Fecha = item.InvoiceDate;
        itemExport.Importe = item.Amount;
        itemExport.Iva = item.AlicuotsColumn;
        itemExport.Corte = item.BillingGroupName;
        // itemExport.CorteInicio = item.BillingGroupFrom;
        // itemExport.CorteFin = item.BillingGroupTo;
        // itemExport.CorteNumero = item.BillingGroupNumber;
        items.push(itemExport);
      });
      this.csvExportService.downloadFile(
        items,
        columns,
        "faturasynotascredito"
      );
    }
  }
}

class BillingInvoiceSearchItemExport {
  public Nro: string;
  public Numero: string;
  public ClienteCodigo: string;
  public Fecha: Date;
  public Importe: string;
  public Iva: string;
  public Corte: string;
  // public CorteInicio: string;
  // public CorteFin: string;
  // public CorteNumero: string;
}

// import { Component, OnInit, ViewChild } from '@angular/core';
// import { SearchFilter, IFilterResponse } from 'src/app/infrastructure/iFilter-component';
// import { MatTableDataSource, MatDialog } from '@angular/material';
// import { BillingInvoiceSearchItem } from 'src/app/model/billing/billing-invoice-search-item';
// import { SearchFilterComponent } from '../../search-filter/search-filter.component';
// import { PagerControlComponent } from '../../controls/pager/pager-control.component';
// import { Router } from '@angular/router';
// import { BillingInvoiceEntityService } from '../../../services/billing/billing-invoice/billing-invoice-entity.service';
// import { BillingCloseTaskDialogComponent } from '../../dialogs/billing-close-task-dialog/billing-close-task-dialog.component';
// import { ScheduledTask } from 'src/app/enums/escheduled-task.enum';
// import { AuthService } from '../../../services/auth.service';
// import { ReportViewerDialogComponent } from '../../dialogs/report-viewer/report-viewer-dialog/report-viewer-dialog.component';
// import { NotificationToastService } from 'src/app/services/notification-toast.service';
// import { MenuService } from '../../../services/menu.service';
// import { BillingReportService } from '../../../services/billing/billing-report.service';
// import { BillingReportTypeDialogComponent } from '../../dialogs/billing-report-type-dialog/billing-report-type-dialog.component';
// import { ConfirmDialogService } from '../../../services/confirm-dialog.service';
// import { of, Observable } from 'rxjs';
// import { BillingExportTypeDialogComponent } from '../../dialogs/billing-export-type-dialog/billing-export-type-dialog.component';
// import { BillingExportFileService } from '../../../services/billing/billing-export-file.service';
// import { DownloadLocalFileService } from '../../../services/download-local-file.service';
// import { Base64ToBlobService } from '../../../services/base64-to-blob.service';

// @Component({
//   selector: 'app-billing-invoice-credit-search',
//   templateUrl: './billing-invoice-credit-search.component.html',
//   styleUrls: ['./billing-invoice-credit-search.component.css']
// })
// export class BillingInvoiceCreditSearchComponent implements OnInit {

//   searchFilters: SearchFilter[];
//   dataSource = new MatTableDataSource([]);
//   billingInvoiceSearchItems: BillingInvoiceSearchItem[] = [];
//   @ViewChild('searchFilter') searchFilter: SearchFilterComponent;
//   @ViewChild('pager') pager: PagerControlComponent;
//   loading: boolean;
//   displayedColumns: string[] = ['invoiceNumber', 'erpCode',
//                                 'invoiceDate', 'amount', 'alicuotsColumn',
//                                 'billingGroupName', 'Star'];

//   constructor( private router: Router,
//                private dialog: MatDialog,
//                private authService: AuthService,
//                private downloadLocalFileService: DownloadLocalFileService,
//                private notificationToastService: NotificationToastService,
//                private base64ToBlobService: Base64ToBlobService,
//                private billingInvoiceEditService: BillingInvoiceEntityService,
//                private menuService: MenuService,
//                private confirmDialogService: ConfirmDialogService,
//                private billingReportService: BillingReportService,
//                private billingExportFileService: BillingExportFileService,
//                private billingInvoiceEntityService: BillingInvoiceEntityService ) {
//     this.menuService.setMenuTitle('Factuas y notas de crédito', '');
//   }

//   ngOnInit() {
//     this.billingReportService.getBillingReportTypeFilters()
//       .then(values => console.log( values ));
//   }

//   selectedPageIndexChange(pagedItems: any[]) {
//     this.dataSource = new MatTableDataSource(pagedItems);
//     this.loading = false;
//   }

//   onEndSearch(response: IFilterResponse<BillingInvoiceSearchItem>) {
//     this.billingInvoiceSearchItems = response.items;
//     this.searchFilters = response.searchFilters;
//     this.pager.setItems(this.billingInvoiceSearchItems);
//   }

//   onStartSearch() {
//     this.loading = true;
//   }

//   redirectCreateInvoiceCredit( billingInvoiceSearchItem: BillingInvoiceSearchItem ) {
//     this.router.navigate([ 'billing-invoice-entity-credit-edit', billingInvoiceSearchItem.InvoiceId ]);
//   }

//   async exportStudyReport( billingInvoiceSearchItem: BillingInvoiceSearchItem ) {

//     billingInvoiceSearchItem.Loading = true;
//     const medicalAppointmentProcedureIds = await this.billingInvoiceEntityService
//           .getMedicalAppointmentProcedureIds( billingInvoiceSearchItem.InvoiceId );
//     billingInvoiceSearchItem.Loading = false;
//     this.dialog.open(BillingCloseTaskDialogComponent, {
//       width: '50%',
//       data: {
//         escheduledTaskId: ScheduledTask.billingExportStudyReport,
//         taskName: `${ this.authService.getUserName().toUpperCase() } - EXPORTACION-INFORMES`,
//         medicalAppointmentProcedureIds: medicalAppointmentProcedureIds,
//         invoiceNumber: billingInvoiceSearchItem.InvoiceNumber,
//         invoicePoint: billingInvoiceSearchItem.InvoicePoint,
//         invoiceLabelType: billingInvoiceSearchItem.InvoiceLabelType
//       }
//     });
//   }

//   async exportImages( billingInvoiceSearchItem: BillingInvoiceSearchItem ) {

//     billingInvoiceSearchItem.Loading = true;
//     const medicalAppointmentProcedureIds = await this.billingInvoiceEntityService
//     .getMedicalAppointmentProcedureIds( billingInvoiceSearchItem.InvoiceId );
//     billingInvoiceSearchItem.Loading = false;
//     this.dialog.open(BillingCloseTaskDialogComponent, {
//       width: '50%',
//       data: {
//         escheduledTaskId: ScheduledTask.billingExportImages,
//         taskName: `${ this.authService.getUserName().toUpperCase() } - EXPORTACION-IMAGENES`,
//         medicalAppointmentProcedureIds: medicalAppointmentProcedureIds,
//         invoiceNumber: billingInvoiceSearchItem.InvoiceNumber,
//         invoicePoint: billingInvoiceSearchItem.InvoicePoint,
//         invoiceLabelType: billingInvoiceSearchItem.InvoiceLabelType
//         }
//     });
//   }

//   async viewReport( billingInvoiceSearchItem: BillingInvoiceSearchItem ) {

//     try {

//       billingInvoiceSearchItem.Loading = true;
//       const reportViewer = await this.billingInvoiceEntityService
//           .getBillingInvoiceReport(billingInvoiceSearchItem.InvoiceId);

//       this.dialog.open(ReportViewerDialogComponent, {
//         width: '90%',
//         height: '600px',
//         data: reportViewer
//       });
//     } catch (err) {
//       this.notificationToastService.error(JSON.stringify(err.error), 'Facturación');
//     } finally {
//       billingInvoiceSearchItem.Loading = false;
//     }
//   }

//   async viewBillingReport( billingInvoiceSearchItem: BillingInvoiceSearchItem ) {

//     const next$ = this.getNextObservable(billingInvoiceSearchItem);

//     next$.subscribe( (value) => {
//        if ( value ) {
//         const billingReportTypeDialog = this.dialog.open(BillingReportTypeDialogComponent, {
//           width: '50%' });
//           billingReportTypeDialog.afterClosed().subscribe(async (id) => {
//             console.log( id );
//             if (id) {
//               await this.showBillingReport(billingInvoiceSearchItem, id);
//             }
//           });
//        }
//     });

//   }

//   async exportBilling( billingInvoiceSearchItem: BillingInvoiceSearchItem ) {

//     const next$ = this.getNextObservable(billingInvoiceSearchItem);

//     next$.subscribe( (value) => {
//        if ( value ) {
//         const billingReportTypeDialog = this.dialog.open(BillingExportTypeDialogComponent, {
//           width: '50%',
//           data: billingInvoiceSearchItem.PreBillingId });
//           billingReportTypeDialog.afterClosed().subscribe(async (id) => {

//             if (id) {

//               const base64File = await this.billingExportFileService
//                   .getBillingExportFile( billingInvoiceSearchItem.InvoiceId, id );

//               this.downloadLocalFileService
//               const blob = this.base64ToBlobService.base64toBlob(base64File, 'application/txt');
//               const downloadURL =  window.URL.createObjectURL(blob);
//               const link = document.createElement('a');
//               // link.href = downloadURL;
//               // const number = this.billingInvoiceEditService.
//               //   .getParentInvoiceCompleteNumber();
//               // link.download = `Factura ${{ number }} .xlsx`;
//               // link.click();
//             }
//           });
//        }
//     });

//   }

//   private getNextObservable(billingInvoiceSearchItem: BillingInvoiceSearchItem):
//     Observable<boolean> {
//     const next$ = billingInvoiceSearchItem.HasCreditNote ?
//     this.confirmDialogService.confirm('Facturación',
//       'Si los protocolos contenidos en esta factura fuera refacturados en otra factura la información puede ser incorrecta. Desea continuar?', 'Sí', 'No')
//       : of(true);
//     return next$;
//   }

//   private async showBillingReport(billingInvoiceSearchItem: BillingInvoiceSearchItem,
//       id: number) {

//     try {
//       billingInvoiceSearchItem.Loading = true;
//       const reportViewer = await this.billingReportService
//         .getBillingReport(id, billingInvoiceSearchItem.InvoiceId, this.authService.getCenterId());
//       this.dialog.open(ReportViewerDialogComponent, {
//         width: '90%',
//         height: '600px',
//         data: reportViewer
//       });
//     } catch (err) {
//       this.notificationToastService.error(JSON.stringify(err.error), 'Facturación');
//     } finally {
//       billingInvoiceSearchItem.Loading = false;
//     }

//   }
// }
